<form class="form vc-admin-form" (ngSubmit)="execute()">
  @if (showIntro) {
    <header class="vc-admin-form__intro">
      <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
      <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
    </header>
  }

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.INFO" | translate }}</h4>
    <div class="grid">
      <div class="col-12 col-12 md:col-6 lg:col-6">
        <div class="field">
          <label>{{ "COMMON.TREATMENT.CATEGORY.NAME" | translate }} *</label>
          <input
            pInputText
            id="treatment-category-name"
            name="name"
            [(ngModel)]="this.payload.name"
            pSize="small"
            fluid
          />
          <small id="user-name-help" class="p-error" *ngIf="this.errors.name">{{
            this.errors.name | translate
          }}</small>
        </div>
      </div>
    </div>
  </section>

  <app-admin-form-actions
    primaryLabelKey="COMMON.SAVE"
    [submitting]="submitting"
  ></app-admin-form-actions>
</form>
